<app-dialog-heading [heading]="'Contributions'"></app-dialog-heading>

<mat-form-field>
  <mat-label>For Contribution Period</mat-label>
  <input matInput [matDatepicker]="picker" [formControl]="date" [max]="maxDate">
  <mat-hint>Year and month</mat-hint>
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker
                  startView="multi-year"
                  (monthSelected)="setMonthAndYear($event, picker)"></mat-datepicker>
</mat-form-field>
<ng-container *ngIf="doesDataExist;then showContributions else emptyPlaceHolder"></ng-container>

<ng-template #showContributions>
  <div class="mat-elevation-z8 table-container contributions-table">
    <table [dataSource]="memberContributionsDataSource" mat-table multiTemplateDataRows>
      <ng-container [matColumnDef]="tableColumns.Date">
        <th *matHeaderCellDef mat-header-cell>Date</th>
        <td *matCellDef="let row" mat-cell>{{ row.date | date:DateUtil.dateFormat }}</td>
      </ng-container>
      <ng-container [matColumnDef]="tableColumns.OpeningBalance">
        <th *matHeaderCellDef mat-header-cell>Opening Balance</th>
        <td *matCellDef="let row" mat-cell>{{ row.openingBalance | currency:row.currency:'symbol-narrow' }}</td>
      </ng-container>
      <ng-container [matColumnDef]="tableColumns.MemberRaised">
        <th *matHeaderCellDef mat-header-cell>Member Raised</th>
        <td *matCellDef="let row" mat-cell>{{ row.memberRaised | currency:row.currency:'symbol-narrow' }}</td>
      </ng-container>
      <ng-container [matColumnDef]="tableColumns.MemberPaid">
        <th *matHeaderCellDef mat-header-cell>Member Paid</th>
        <td *matCellDef="let row" mat-cell>{{ row.memberPaid | currency:row.currency:'symbol-narrow' }}</td>
      </ng-container>
      <ng-container [matColumnDef]="tableColumns.CompanyRaised">
        <th *matHeaderCellDef mat-header-cell>Company Raised</th>
        <td *matCellDef="let row" mat-cell>{{ row.companyRaised | currency:row.currency:'symbol-narrow' }}</td>
      </ng-container>
      <ng-container [matColumnDef]="tableColumns.CompanyPaid">
        <th *matHeaderCellDef mat-header-cell>Company Paid</th>
        <td *matCellDef="let row" mat-cell>{{ row.companyPaid | currency:row.currency:'symbol-narrow' }}</td>
      </ng-container>
      <ng-container [matColumnDef]="tableColumns.ClosingBalance">
        <th *matHeaderCellDef mat-header-cell>Closing Balance</th>
        <td *matCellDef="let row" mat-cell>{{ row.closingBalance | currency:row.currency:'symbol-narrow' }}</td>
      </ng-container>
      <ng-container [matColumnDef]="tableColumns.Total">
        <th *matHeaderCellDef mat-header-cell>Total</th>
        <td *matCellDef="let row" mat-cell>{{ row.total | currency:row.currency:'symbol-narrow' }}</td>
      </ng-container>
      
      <tr mat-header-row *matHeaderRowDef="tableDisplayedColumns; sticky: true;"></tr>
      <tr mat-row *matRowDef="let row; columns: tableDisplayedColumns"></tr>
    </table>
  </div>
</ng-template>

<ng-template #emptyPlaceHolder>
  <div class="text-center">
    <label class="column-label claim-column-label">No contribution data</label>
  </div>
</ng-template>